// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/shared/media/youtube-video.component.scss
// module id = 183
// module chunks = 0